import React, { createContext, useContext, useState } from 'react';
import { EntityPermission, ViewPermission, ActionPermission } from '../types';

interface AccessLevelContextType {
  entityPermissions: Array<EntityPermission>;
  setEntityPermissions: (entityPermissions: Array<EntityPermission>) => void;
  viewPermissions: Array<ViewPermission>;
  setViewPermissions: (navigationPermission: Array<ViewPermission>) => void;
  actionPermissions: Array<ActionPermission>;
  setActionPermissions: (actionPermissions: Array<ActionPermission>) => void;
  loadingPermissions: boolean;
  setLoadingPermissions: (loading: boolean) => void;
}

const AccessLevelContext = createContext<AccessLevelContextType>({
  entityPermissions: [],
  setEntityPermissions: () => {},
  viewPermissions: [],
  setViewPermissions: () => {},
  actionPermissions: [],
  setActionPermissions: () => {},
  loadingPermissions: true,
  setLoadingPermissions: () => {},
});

interface AccesLevelProviderProps {
  children: React.ReactNode;
}

export const AccessLevelProvider = ({ children }: AccesLevelProviderProps) => {
  const [entityPermissions, setEntityPermissions] = useState<
    EntityPermission[]
  >([]);
  const [viewPermissions, setViewPermissions] = useState<ViewPermission[]>([]);
  const [actionPermissions, setActionPermissions] = useState<
    ActionPermission[]
  >([]);
  const [loadingPermissions, setLoadingPermissions] = useState<boolean>(false);
  return (
    <AccessLevelContext.Provider
      value={{
        entityPermissions,
        viewPermissions,
        actionPermissions,
        setEntityPermissions,
        setViewPermissions,
        setActionPermissions,
        loadingPermissions,
        setLoadingPermissions,
      }}
    >
      {children}
    </AccessLevelContext.Provider>
  );
};

export const useAccessLevelContext = (): AccessLevelContextType => {
  const context = useContext(AccessLevelContext);

  if (!context) {
    throw new Error(
      'useAccessLevelContext must be used within a AccessLevelProvider'
    );
  }

  return context;
};
